import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React, { FC, useContext, useState } from 'react';

import RightDrawer from '@/components/RightDrawer';
import useIsMobile from '@/hooks/useIsMobile';

import ResourceContext from '../../context';
import { RootMenu } from '../../types';
import Menu from '../Menu';

interface Props {
  data: RootMenu[];
}

const FilterConditionMobile: FC<Props> = ({ data }) => {
  const { t } = useTranslation('resources');
  const { filterTags, query, setQueryAndUpdatePath, resourceList } =
    useContext(ResourceContext);
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  const { totalCount } = resourceList?.content || { totalCount: 0 };
  const isMobile = useIsMobile();

  return (
    <div className="mobile:mb-[8px] pc:mb-[24px]">
      <div className="flex items-center justify-between py-[24px]">
        <div className="box-border  flex rounded-[4px] border-[1px] border-solid border-[#F0F1FC] text-[14px]">
          <span
            onClick={() =>
              setQueryAndUpdatePath({ order: 'publish', page: '1' })
            }
            className={classNames(
              'flex h-[28px] items-center border-r-[1px] border-solid border-[#F0F1FC] px-[8px]',
              {
                'bg-[#FFF5F5] text-[#FF5353]': query?.order === 'publish',
              },
            )}>
            {t('最新发布')}
          </span>
          <span
            onClick={() => setQueryAndUpdatePath({ order: 'view', page: '1' })}
            className={classNames('flex h-[28px] items-center px-[8px]', {
              'bg-[#FFF5F5] text-[#FF5353]': query?.order === 'view',
            })}>
            {t('浏览最多')}
          </span>
        </div>
        <div onClick={() => setMenuVisible(true)} className="flex items-center">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V4.6275C1.49989 4.93721 1.56372 5.2436 1.6875 5.5275V5.5725C1.79346 5.81323 1.94354 6.032 2.13 6.2175L6.75 10.8075V15.75C6.74975 15.8775 6.78198 16.0029 6.84365 16.1144C6.90533 16.226 6.99442 16.3199 7.1025 16.3875C7.22186 16.4615 7.35958 16.5005 7.5 16.5C7.61741 16.4993 7.73301 16.471 7.8375 16.4175L10.8375 14.9175C10.9612 14.8552 11.0652 14.7598 11.138 14.642C11.2108 14.5242 11.2496 14.3885 11.25 14.25V10.8075L15.84 6.2175C16.0265 6.032 16.1765 5.81323 16.2825 5.5725V5.5275C16.4166 5.24582 16.4907 4.93933 16.5 4.6275V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5ZM9.9675 9.9675C9.89799 10.0376 9.843 10.1207 9.80567 10.2121C9.76835 10.3034 9.74943 10.4013 9.75 10.5V13.785L8.25 14.535V10.5C8.25057 10.4013 8.23165 10.3034 8.19433 10.2121C8.15701 10.1207 8.10201 10.0376 8.0325 9.9675L4.0575 6H13.9425L9.9675 9.9675ZM15 4.5H3V3.75C3 3.55109 3.07902 3.36032 3.21967 3.21967C3.36032 3.07902 3.55109 3 3.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5Z"
              fill={filterTags?.length ? '#FF5353' : '#1B1F4D'}
            />
          </svg>
          <span
            className={classNames('ml-[3px]  font-semibold', {
              'text-[#FF5353]': filterTags?.length,
              'text-[#1B1F4D]': !filterTags?.length,
            })}>
            {t('筛选')}
          </span>
        </div>
      </div>
      <div
        className="rounded-[20px] bg-[#F8F9FF] px-[16px] py-[6px] text-[14px] text-[#8D8FA6]"
        dangerouslySetInnerHTML={{
          __html: t('资源条数', { total: totalCount }),
        }}
      />
      <RightDrawer
        visible={menuVisible}
        handleClose={() => setMenuVisible(false)}
        hideHeader={isMobile}
        title={
          <div className="flex items-center">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V4.6275C1.49989 4.93721 1.56372 5.2436 1.6875 5.5275V5.5725C1.79346 5.81323 1.94354 6.032 2.13 6.2175L6.75 10.8075V15.75C6.74975 15.8775 6.78198 16.0029 6.84365 16.1144C6.90533 16.226 6.99442 16.3199 7.1025 16.3875C7.22186 16.4615 7.35958 16.5005 7.5 16.5C7.61741 16.4993 7.73301 16.471 7.8375 16.4175L10.8375 14.9175C10.9612 14.8552 11.0652 14.7598 11.138 14.642C11.2108 14.5242 11.2496 14.3885 11.25 14.25V10.8075L15.84 6.2175C16.0265 6.032 16.1765 5.81323 16.2825 5.5725V5.5275C16.4166 5.24582 16.4907 4.93933 16.5 4.6275V3.75C16.5 3.15326 16.2629 2.58097 15.841 2.15901C15.419 1.73705 14.8467 1.5 14.25 1.5ZM9.9675 9.9675C9.89799 10.0376 9.843 10.1207 9.80567 10.2121C9.76835 10.3034 9.74943 10.4013 9.75 10.5V13.785L8.25 14.535V10.5C8.25057 10.4013 8.23165 10.3034 8.19433 10.2121C8.15701 10.1207 8.10201 10.0376 8.0325 9.9675L4.0575 6H13.9425L9.9675 9.9675ZM15 4.5H3V3.75C3 3.55109 3.07902 3.36032 3.21967 3.21967C3.36032 3.07902 3.55109 3 3.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75V4.5Z"
                fill={filterTags?.length ? '#FF5353' : '#1B1F4D'}
              />
            </svg>
            <span
              className={classNames('ml-[3px] font-bold', {
                'text-[#FF5353]': filterTags?.length,
                'text-[#1B1F4D]': !filterTags?.length,
              })}>
              {t('筛选')}
            </span>
          </div>
        }>
        <Menu
          visible={menuVisible}
          handleClose={() => setMenuVisible(false)}
          data={data}
        />
      </RightDrawer>
    </div>
  );
};

export default FilterConditionMobile;
